import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsArrowRepeat, BsPencil, BsThreeDotsVertical, BsTrash } from 'react-icons/bs';

import Menu from '#globalComponents/Overlay/Menu';
import Popover from '#globalComponents/Overlay/Popover';

/**
 * Actions of a custom column, opened from its table header.
 */
const CustomColumnHeaderMenu = ({ column, onEdit, onFill, onDelete }) => {
	const [open, setOpen] = useState(false);
	const run = (action) => () => {
		setOpen(false);
		action(column);
	};

	const trigger = (
		<button
			type="button"
			onClick={() => setOpen((prev) => !prev)}
			className="p-0.5 rounded text-bgBase-800 hover:text-primary-600 transition-colors"
			title={`Variable {${column.key}}`}
		>
			<BsThreeDotsVertical className="w-3.5 h-3.5" />
		</button>
	);

	return (
		<Popover open={open} onClose={() => setOpen(false)} trigger={trigger} size="s" align="center">
			<Menu>
				<Menu.Label>{`Variable {${column.key}}`}</Menu.Label>
				<Menu.Item icon={BsPencil} onClick={run(onEdit)}>
					Bearbeiten & testen
				</Menu.Item>
				{column.type === 'ai' && (
					<>
						<Menu.Item icon={BsArrowRepeat} onClick={run((c) => onFill(c, 'missing'))}>
							Fehlende Werte befüllen
						</Menu.Item>
						<Menu.Item icon={BsArrowRepeat} onClick={run((c) => onFill(c, 'all'))}>
							Alle neu befüllen
						</Menu.Item>
					</>
				)}
				<Menu.Separator />
				<Menu.Item icon={BsTrash} tone="danger" onClick={run(onDelete)}>
					Spalte löschen
				</Menu.Item>
			</Menu>
		</Popover>
	);
};

CustomColumnHeaderMenu.propTypes = {
	column: PropTypes.shape({ id: PropTypes.string, key: PropTypes.string, type: PropTypes.string }).isRequired,
	onEdit: PropTypes.func.isRequired,
	onFill: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
};

export default CustomColumnHeaderMenu;
